import styled from 'styled-components';

export const StyledApplication = styled.div`
  margin: 20px;
  padding: 30px;
  min-height: 750px;
`;
